import { useInView } from '../../hooks/in-view';
import styles from './concept.module.css'
import Marquee from "react-fast-marquee";
import matsuriTextImg from '../../assets/gfx/matsuri-text.svg'

function ConceptSlide({lang}) {
    const {ref, inView} = useInView({
        threshold: 0.5,
    }, {
        once: true,
        resetOnExit: false
    });

    const texts = {
        EN: [
            "A festival hosted by Orin",
            "For the sake of playing fun, casual",
            "matches with everyone",
            "The main rule is to have fun!",
            "There will be matches with special rules!",
            "Dec. 14th 6:00 PM JST!",
        ],
        JA: [
            "初めてオリンがホストする",
            "お祭りのようにみんなで楽しくわいわい遊ぶ",
            "超~カジュアルカスタムマッチ!",
            "メインルールは楽しむこと!",
            "ユニークマッチで賞金ゲットだ！",
            "12 月 14 日 18:00 スタート！"
        ]
    };

    return (
        <div className={styles.wrapper}>
            <div id="concept" className={styles.container} ref={ref}>
                <div className={styles.flair}><Marquee speed={80} autoFill={true} className={styles['flair-text']}>concept concept concept concept concept concept concept concept concept&nbsp;</Marquee></div>
                <div className={styles.content}>
                    <div className={styles['content-title']}>
                        <span className={styles['content-title-text']}>
                            Concept
                            <img src={matsuriTextImg} className={styles['content-title-oshare']} alt="matsuri" />
                        </span>
                    </div>
                    <div className={`${styles['content-text-left']} ${inView ? styles['context-text-visible-0'] : ''}`}>{texts[lang][0]}</div>
                    <div className={`${styles['content-text-right']} ${inView ? styles['context-text-visible-1'] : ''}`}>{texts[lang][1]}</div>
                    <div className={`${styles['content-text-left']} ${inView ? styles['context-text-visible-2'] : ''}`}>{texts[lang][2]}</div>
                    <div className={`${styles['content-text-right']} ${inView ? styles['context-text-visible-3'] : ''}`}>{texts[lang][3]}</div>
                    <div className={`${styles['content-text-left']} ${inView ? styles['context-text-visible-4'] : ''}`}>{texts[lang][4]}</div>
                </div>
                <div className={styles.date}>
                    <span className={`${styles.bubble} ${inView ? styles['bubble-visible'] : ''}`}>
                        {texts[lang][5]}
                    </span>

                    {lang === "JA" && (
                        <a
                            href="https://yuusha-orin.app/ja/news/01K9XPWSS6WVHS1M7D4V82VCZF"       
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${styles.detailButton} ${inView ? styles['detail-visible'] : ''}`}
                        >
                            マッチ詳細はここから！
                        </a>
                    )}
                    {lang === "EN" && (
                        <a
                            href="https://yuusha-orin.app/en-US/news/01K9XPWSS6WVHS1M7D4V82VCZF"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${styles.detailButton} ${inView ? styles['detail-visible'] : ''}`}
                        >
                            Match Overview here
                        </a>
                    )}
                </div>
                <div className={`${styles.flair} ${styles.flip}`}><Marquee speed={80} autoFill={true} className={styles['flair-text']}>concept concept concept concept concept concept concept concept concept&nbsp;</Marquee></div>
            </div>
        </div>
    )
}

export default ConceptSlide